/**
 * スクロールに応じてボディクラスを制御する関数
 * @param {Function} func - 実行する関数
 * @param {number} wait - 待機時間（ミリ秒）
 * @returns {Function} - throttle処理された関数
 */
const throttle = (func, wait = 100) => {
    let timeout = null;
    return (...args) => {
        if (!timeout) {
            timeout = setTimeout(() => {
                func.apply(this, args);
                timeout = null;
            }, wait);
        }
    };
};

/**
 * スクロール位置に応じてボディクラスを更新する
 */
const updateScrollClasses = () => {
    const { scrollY, innerHeight } = window;
    const { scrollHeight } = document.documentElement;
    const footerInfo = document
        .querySelector(".footer")
        ?.getBoundingClientRect();

    // クラスの更新をまとめて処理
    const classes = {
        vh: scrollY >= innerHeight,
        top: scrollY === 0,
        notTop: scrollY > 0,
        "in-footer": footerInfo.top < innerHeight && scrollY > 10,
    };

    // クラスの一括更新
    Object.entries(classes).forEach(([className, condition]) => {
        document.body.classList[condition ? "add" : "remove"](className);
    });
};

// throttleを適用したスクロールハンドラを設定
window.addEventListener("scroll", throttle(updateScrollClasses, 100));

// 初期実行
updateScrollClasses();

/**
 * 要素のスクロール可能状態を監視して、指定された親要素にクラスを付与するよ！
 * - スクロールできない場合は最初から'scrolled-x'や'scrolled-y'クラスが付くよ
 * - スクロール可能な場合はスクロール位置に応じてクラスが切り替わるよ
 *
 * @param {string} selector - 監視したい要素のCSSセレクター
 * @param {string} closestSele - クラスを付与する親要素のセレクター
 * @param {boolean} watchResize - リサイズ監視するかどうか（デフォルトはfalse）
 *
 * @example
 * // 基本的な使い方
 * watchDirectionalScroll('.scroll-area', '.container');
 *
 * // リサイズ監視ありの場合
 * watchDirectionalScroll('.scroll-area', '.container', true);
 */
const watchDirectionalScroll = (selector, closestSele, watchResize = false) => {
    const elements = document.querySelectorAll(selector);

    const checkScrollable = (element) => {
        const parentElement = element.closest(closestSele);
        if (!parentElement) return;

        const isScrollableX = element.scrollWidth > element.clientWidth;
        const isScrollableY = element.scrollHeight > element.clientHeight;

        // 横スクロールの状態をチェック
        if (!isScrollableX) {
            parentElement.classList.add("scrolled-x");
        } else if (element.scrollLeft === 0) {
            parentElement.classList.remove("scrolled-x");
        }

        // 縦スクロールの状態をチェック
        if (!isScrollableY) {
            parentElement.classList.add("scrolled-y");
        } else if (element.scrollTop === 0) {
            parentElement.classList.remove("scrolled-y");
        }
    };

    elements.forEach((element) => {
        // 初期状態のチェック
        checkScrollable(element);

        // スクロールイベントの監視
        element.addEventListener("scroll", () => {
            const parentElement = element.closest(closestSele);
            if (!parentElement) return;

            if (element.scrollLeft > 0) {
                parentElement.classList.add("scrolled-x");
            } else {
                if (element.scrollWidth > element.clientWidth) {
                    // parentElement.classList.remove("scrolled-x");
                }
            }

            if (element.scrollTop > 0) {
                parentElement.classList.add("scrolled-y");
            } else {
                if (element.scrollHeight > element.clientHeight) {
                    // parentElement.classList.remove("scrolled-y");
                }
            }
        });

        // リサイズ監視が必要な場合
        if (watchResize) {
            const resizeObserver = new ResizeObserver(() => {
                checkScrollable(element);
            });
            resizeObserver.observe(element);
        }
    });
};

if (document.body.classList.contains("page-history-0")) {
    watchDirectionalScroll(
        ".his__rowScroll .simplebar-content-wrapper",
        ".his__row"
    );
}
